import { useEffect, type RefObject } from 'react';

/**
 * Kaydırınca açılan bölümler: kök altındaki `.zh-reveal` öğeleri görünüme
 * girince `.zh-in` alır (stil: styles/landing.css). Gözlemci yoksa kök
 * `.zh-rv` almaz, her şey baştan görünür kalır.
 *
 * `key` değişince (ör. aynı şablonu kullanan sayfalar arası geçiş) yeni
 * öğeler yeniden gözlenir.
 */
let firstMount = true;

export function useReveal(rootRef: RefObject<HTMLElement | null>, key?: unknown) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root || !('IntersectionObserver' in window)) return;
    // İlk yüklemede (ön-çizilmiş HTML'e bağlanırken) ekranda zaten görünen öğeler hemen `.zh-in` alır: kök `.zh-rv`
    // olunca bir kare gizlenip yeniden belirmeleri PageSpeed'de Speed Index'i ve göze çarpan bir yanıp sönmeyi
    // getiriyordu. Sayfa içi geçişlerde (`key` değişimi) animasyon olduğu gibi kalır.
    const instant = firstMount;
    firstMount = false;
    root.classList.add('zh-rv');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('zh-in');
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    root.querySelectorAll('.zh-reveal:not(.zh-in)').forEach((el) => {
      const r = instant ? el.getBoundingClientRect() : null;
      if (r && r.height > 0 && r.top < window.innerHeight && r.bottom > 0) el.classList.add('zh-in');
      else io.observe(el);
    });
    return () => io.disconnect();
  }, [rootRef, key]);
}
